import styled from '@emotion/styled';
import { Chip } from '@mui/material';

import { theme } from '@/theme';

export const StyledNavChip = styled(Chip)`
    max-height: 1.3rem;
    background-color: ${theme.palette.components.chipBg};
    color: ${theme.palette.common.white};
    font-size: 0.8rem;
    line-height: 0.8rem;
    font-weight: medium;
    transform: translateY(2px);

    span.MuiChip-label {
        padding-left: 0.4rem;
        padding-right: 0.4rem;
    }
`;
